import { render, staticRenderFns } from "./TicketFormV2.vue?vue&type=template&id=46f20b83&scoped=true&"
import script from "./TicketFormV2.vue?vue&type=script&lang=js&"
export * from "./TicketFormV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f20b83",
  null
  
)

export default component.exports